import { combineReducers } from "redux";
import { DESTROY_SESSION } from "../actions/type";
import auth from "./auth";
import assistants from "./assistants";

const appReducer = combineReducers({
  auth,
  assistants,
});

const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if (action.type === DESTROY_SESSION) {
    state = undefined;
    action = { type: "@@INIT" };
  }
  return appReducer(state, action);
};

export default rootReducer;
